/**
 * Typed fetchers for /api/v1/grants.
 *
 * Types come from the OpenAPI-generated schema. Regenerate via
 * `pnpm gen:api` after a backend Pydantic change.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type GrantOut = components["schemas"]["daquma__api__v1__grants__GrantOut"];
export type GrantListOut = components["schemas"]["GrantListOut"];
export type CreateGrantInput = components["schemas"]["CreateGrantIn"];

export function listGrants(
  token: string,
  opts: {
    user_id?: string | null;
    resource_type?: string | null;
    include_revoked?: boolean;
  } = {},
): Promise<GrantListOut> {
  const params = new URLSearchParams();
  if (opts.user_id) params.set("user_id", opts.user_id);
  if (opts.resource_type) params.set("resource_type", opts.resource_type);
  if (opts.include_revoked) params.set("include_revoked", "true");
  const qs = params.toString();
  return apiFetch<GrantListOut>(`/api/v1/grants${qs ? `?${qs}` : ""}`, { token });
}

export function createGrant(token: string, input: CreateGrantInput): Promise<GrantOut> {
  return apiFetch<GrantOut>("/api/v1/grants", { method: "POST", token, json: input });
}

export function revokeGrant(token: string, grantId: string, reason: string): Promise<void> {
  return apiFetch<void>(`/api/v1/grants/${encodeURIComponent(grantId)}`, {
    method: "DELETE",
    token,
    json: { reason },
  });
}
